import React, { Component } from 'react'
import { ACCOUNT_DASHBOARD_API, ACCOUNT_LISTING, ACCOUNT_RATEDECK_DOWNLOAD, Account_STATUS_CHANGE, ACCOUNT_DELETE, LOGIN_URL } from '../../config/rest_endpoints';
import { getUser } from '../../actions/session';
import { Notifications } from '../common/notification';
import { Link, withRouter, Redirect } from 'react-router-dom'
import axios from 'axios'
import CustomLoader from '../common/loader';
import { ACCOUNT_CREATE, ADDITIONAL_ACCOUNT_INFO, RC_LOAD_LOGIN, USER_URL } from '../routers/RouteConstants';
import CustomModal from '../common/modal';
import AddAccount from './addAccount';
import EditAccount from './editAccountModal';
import Switch from "react-switch";
import Pagination from "react-js-pagination";
import { CSVLink } from 'react-csv';
import Select from 'react-select';
import { fmtDollar4, fmtMins, fmtInt } from '../common/formatters';


export class AccountTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            User: getUser(),
            isGetting: false,
            accountTable: [],
            message: '',
            isAddModal: false,
            isEditModal: false,
            searchValue: '',
            editData: [],
            updateMsg: '',
            activePage: 1,
            itemsCount: 10,
            totalCount: null,
            isExpire: false,
            tableData:[],
            csvData:[],
            filterStatus : { label: 'All', value: 'all' },
            countList : [
                { label: 'All', value: 'all' },
                { label: 'Enabled', value: 'Enabled' },
                { label: 'Disabled', value: 'Disabled' },
                { label: 'Credit-Hold', value: 'Credit-Hold' },
            ],
            isDeleting: false,
            isDeleteModal: false,
            deleteData: null,
        }
        // this.accountListing = this.accountListing.bind(this)
        this.openAddModal = this.openAddModal.bind(this)
        this.closeAddModal = this.closeAddModal.bind(this)
        this.closeEditModal = this.closeEditModal.bind(this)
        this.openEditModal = this.openEditModal.bind(this)
        this.searchSpace = this.searchSpace.bind(this)
        this.closeLogOutModal = this.closeLogOutModal.bind(this)
        this.goLoginPage = this.goLoginPage.bind(this)
        this.getTable = this.getTable.bind(this)
        this.handleDelete = this.handleDelete.bind(this)
        this.openDeleteModal = this.openDeleteModal.bind(this)
        this.closeDeleteModal = this.closeDeleteModal.bind(this)
    }

    componentDidMount() {
        // this.accountListing()
        this.getTable()
    }

    openLogOutModal() {
        this.setState({ isExpire: true })
    }

    closeLogOutModal() {
        this.setState({ isExpire: false })
    }

    closeAddModal() {
        this.setState({
            isAddModal: false
        })
    }

    openAddModal() {
        // this.setState({
        //     isAddModal: true
        // })
        this.props.history.push(ACCOUNT_CREATE)
    }

    openEditModal(row) {
        this.setState({
            isEditModal: true,
            editData: row
        })
    }

    closeEditModal() {
        this.setState({
            isEditModal: false
        })
    }

    openDeleteModal(row) {
        this.setState({ isDeleteModal: true, deleteData: row });
    }

    closeDeleteModal() {
        this.setState({ isDeleteModal: false, deleteData: null });
    }

    handleDelete() {
        const { User, deleteData } = this.state;
        if (!deleteData) return;
        const headers = { Authorization: `Bearer ${User.token}` };
        this.setState({ isDeleting: true });
        axios.delete(`${ACCOUNT_DELETE}/${deleteData.id}`, { headers })
            .then((res) => {
                const msg = res.data && res.data.message ? res.data.message : 'Account deleted successfully';
                Notifications.notify(msg, 'Success', 'success');
                this.getTable();
            })
            .catch((err) => {
                const errorMsg = err.response && err.response.data && err.response.data.message
                    ? err.response.data.message
                    : 'An unknown error occurred.';
                Notifications.notify(errorMsg, 'Failed', 'error');
                if (err.response && err.response.data.message === 'invalid or expired jwt') {
                    localStorage.removeItem('user');
                    this.props.history.push(LOGIN_URL);
                }
            })
            .finally(() => {
                this.setState({ isDeleting: false });
                this.closeDeleteModal();
            });
    }

    searchSpace(e) {
        this.setState({ searchValue: e.target.value })
    }

    handlePageChange(pageNumber) {
        this.setState({
            activePage: pageNumber
        }, () => {
            // this.accountListing()
        });
    }

    // accountListing() {
    //     const { User, itemsCount, activePage } = this.state
    //     this.setState({
    //         isGetting: true
    //     })
    //     var headers = { "Authorization": "Bearer " + User.token };
    //     axios.get(`${ACCOUNT_LISTING}?page=${activePage}&search=&limit=${itemsCount}`, { headers }).then(res => {
    //         if (res) {
    //             var resp = res.data
    //             console.log('resp :>> ', resp);
    //             this.setState({
    //                 accountTable: resp.data,
    //                 message: resp.message,
    //                 isGetting: false,
    //                 totalCount: resp.pageinfo.totalCount
    //             })
    //         }
    //         else {
    //             this.setState({
    //                 isGetting: true
    //             })
    //             Notifications.notify("Fetch failed", "error", "errors");
    //         }
    //     }).catch(err => {
    //         var logs = err.response.status
    //         console.log('logs :>> ', logs);
    //         if (logs === 401) {
    //             localStorage.removeItem('user');
    //             this.setState({ isExpire: true })
    //             //this.props.history.push(RC_LOAD_LOGIN);
    //         }else {
    //             Notifications.notify(logs, "error", "errors");
    //         }
    //     })
    // }

    handleSelectChange = (selectedOption) => {
        this.setState({ filterStatus: selectedOption },() => {
            this.getTable()
            console.log("filterStatus", this.state.filterStatus)
        });
      };

    getTable() {
        const {User,filterStatus} = this.state
        this.setState({isGetting:true})
        var headers = { "Authorization": "Bearer " + User.token };
        axios.get(`${ACCOUNT_DASHBOARD_API}`,{headers}).then(res=>{
            if(res) {
                const all = res.data.data
                const enabledAccount = all.filter(item => item.status === "Enabled")
                const disabledAccount = all.filter(item => item.status === "Disabled")
                const creditHoldAccount = all.filter(item => item.status === "Credit-Hold")
                console.log('all', all)
                console.log('enabledAccount', enabledAccount)
                console.log('disabledAccount',disabledAccount)
                console.log('reditHoldAccount', creditHoldAccount)

                // console.log('inactiveAccount', inactiveAccount)
                const resp = filterStatus.value === 'all' ? all : filterStatus.value === 'Enabled'  ? enabledAccount : filterStatus.value === 'Disabled'  ? disabledAccount : creditHoldAccount || []
                console.log(`res`, res)
                this.setState({
                    tableData:resp,
                    isGetting:false
                })
            }
        }).catch(err=>{
            const alert = err.response
            if (alert.data.message === 'invalid or expired jwt') {
                localStorage.removeItem('user');
                this.props.history.push(LOGIN_URL)
                Notifications.notify(alert.data.message, "Token Expire", "error")
            }
            Notifications.notify(alert.data.message, "Failed", "error")
            this.setState({
                isGetting:false
            })
        })
    }

    handleDownload(id) {
        const {User} = this.state
        var headers = { "Authorization": "Bearer " + User.token };
        axios.get(`${ACCOUNT_RATEDECK_DOWNLOAD}?file=${id}`,{headers}).then(res=>{
            let content = res.headers['content-disposition']
            if(res) {
                var resp = res.data
                var short = content.split("filename=")[1]
                var filename = short.replace(/['"]+/g, '')
                const url = window.URL.createObjectURL(new Blob([resp])) 
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', `${filename}.csv`)
                document.body.appendChild(link)
                link.click()
            }
        }).catch(err=>{
            const alert = err.response
            if (alert.data.message === 'invalid or expired jwt') {
                localStorage.removeItem('user');
                this.props.history.push(LOGIN_URL)
                Notifications.notify(alert.data.message, "Token Expire", "error")
            }
            Notifications.notify(alert.data.message, "Failed", "error")
        })
    }

    __renderAccountTable() {
        const { tableData, searchValue } = this.state
        var nullData = (
            <div className="ml-4 mt-2">
                <div className="dataTables_info" id="DataTables_Table_0_info" role="status" aria-live="polite">Showing 0 of 0 entries</div>
                <div className="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate"></div>
            </div>
        )
        if (!tableData.length) {
            return nullData
        }
        else {
            return tableData.filter(table => {
                if (searchValue == null) {
                    return table
                }
                else if (table.accountName.toLowerCase().includes(searchValue.toLowerCase())) {
                    return table
                }
            }).map((row, idx) => {
                const isDeleteDisabled = row.status !== 'Disabled' || this.state.isDeleting;
                return (
                     <tr key={idx}>
                        <td onClick={this.onRedirecting.bind(this, row.id, row.accountName, row.billingType)}>
                            <Link>
                                <span className={row.status === 'Enabled' ? 'text-success' : row.status === 'Credit Hold' ? 'text-primary' : 'text-danger'}>{row.accountName}</span>
                            </Link>
                        </td>
                        <td style={{textAlign:'right'}}>{fmtDollar4(row.balance)}</td>
                        <td style={{textAlign:'right'}}>{fmtDollar4(row.spent)}</td>
                        <td style={{textAlign:'right'}}>{fmtInt(row.sessions)}</td>
                        <td style={{textAlign:'right'}}>{row.sessionsPCT}</td>
                        <td style={{textAlign:'right'}}>{fmtInt(row.CPS)}</td>
                        <td style={{textAlign:'right'}}>{row.CPSPCT}</td>
                        <td style={{textAlign:'right'}}>{row.ASR}</td>
                        <td style={{textAlign:'right'}}>{row.ACD}</td>
                        <td style={{textAlign:'right'}}>{row.SDP}</td>
                        <td style={{textAlign:'right'}}>{fmtDollar4(row.yesterdaySpent)}</td>
                        <td style={{textAlign:'right'}}>{fmtDollar4(row.profit)}</td>
                        <td style={{textAlign:'center'}}>
                            <button
                                className="btn btn-sm btn-primary"
                                onClick={this.portalLogin.bind(this, row.id)}
                                title="Login as this account"
                            >
                                Portal
                            </button>
                        </td>
                        <td>{row.rate.includes('csv') ? <Link onClick={this.handleDownload.bind(this, row.billingType)}>{row.rate === '' ? 'N/A' : row.rate}</Link> : row.rate === '' ? 'N/A' : row.rate}</td>
                        <td style={{textAlign:'center'}}>
                            <i
                                className={`fa fa-trash text-danger${isDeleteDisabled ? ' disabled' : ''}`}
                                style={{ cursor: isDeleteDisabled ? 'not-allowed' : 'pointer', opacity: isDeleteDisabled ? 0.5 : 1 }}
                                onClick={() => { if (!isDeleteDisabled) this.openDeleteModal(row); }}
                                title={row.status !== 'Disabled' ? 'Can only delete Disabled accounts' : this.state.isDeleting ? 'Please wait...' : 'Delete'}
                            ></i>
                        </td>
                    </tr>
                )
            })
        }

    }


    returnTotal() {
        const {tableData} = this.state
        let totalBalance = []
        let totalSpent = []
        let totalSession = []
        let totalSessionPCT = [] 
        let totalCPS = []
        let totalCPSPct = []
        let totalASR = [] 
        let totalACD = [] 
        let totalSDP = [] 
        let totalYesterdaySpent = [] 
        let totalProfit = []
        
        // Helper to check if any value is float
        const hasFloat = arr => arr.some(v => Number(v) % 1 !== 0);
        // Helper to sum and format
        const sumAndFormat = (arr) => {
            const sum = arr.reduce((a, b) => Number(a) + Number(b), 0);
            return hasFloat(arr) ? sum.toFixed(2) : parseInt(sum);
        }
        
        if(tableData.length>1) {
             tableData.forEach((item) => {
                 totalBalance.push(item['balance'])
                 totalSpent.push(item['spent'])
                 totalSession.push(item['sessions'])
                 totalSessionPCT.push(item['sessionsPCT'])
                 totalCPS.push(item['CPS'])
                 totalCPSPct.push(item['CPSPCT'])
                 totalASR.push(item['ASR'])
                 totalACD.push(item['ACD'])
                 totalSDP.push(item['SDP'])
                 totalYesterdaySpent.push(item['yesterdaySpent'])
                 totalProfit.push(item['profit'])
            })
            return (
                <tr >
                    <td  style={{fontWeight:'bolder'}}> Total</td>
                    <td style={{textAlign:'right'}}> {fmtDollar4(sumAndFormat(totalBalance))}</td>
                    <td style={{textAlign:'right'}}> {fmtDollar4(sumAndFormat(totalSpent))}</td>
                    <td style={{textAlign:'right'}}> {fmtInt(sumAndFormat(totalSession))}</td>
                    <td style={{textAlign:'right'}}> {sumAndFormat(totalSessionPCT)}</td>
                    <td style={{textAlign:'right'}}> {fmtInt(sumAndFormat(totalCPS))}</td>
                    <td style={{textAlign:'right'}}> {sumAndFormat(totalCPSPct)}</td>
                    <td style={{textAlign:'right'}}> {sumAndFormat(totalASR)}</td>
                    <td style={{textAlign:'right'}}> {sumAndFormat(totalACD)}</td>
                    <td style={{textAlign:'right'}}> {sumAndFormat(totalSDP)}</td>
                    <td style={{textAlign:'right'}}> {fmtDollar4(sumAndFormat(totalYesterdaySpent))}</td>
                    <td style={{textAlign:'right'}}> {fmtDollar4(sumAndFormat(totalProfit))}</td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
            )
           
        }
    }


    goLoginPage() {
        this.props.history.push(RC_LOAD_LOGIN)
    }

    // toggleSwitch(row) {
    //     const { User } = this.state
    //     var user = row;
    //     const data = {
    //         "status": !user.status
    //     }
    //     var headers = { "Authorization": "Bearer " + User.token };
    //     axios.put(`${Account_STATUS_CHANGE}/${user.id}/changeStatus`, data, { headers }).then(res => {
    //         this.setState({
    //             updateMsg: res.data.message
    //         })
    //         this.accountListing()
    //         Notifications.notify(this.state.updateMsg, "Success", "success");
    //     })

    // }

    portalLogin(accountId) {
        const { User } = this.state;
        window.open(`${USER_URL}/user/${accountId}/token/${User.token}`, '_blank');
    }

    onRedirecting(id,accountName,type) {
        let checkType = type === '' ? 'flatrate' : type
        this.props.history.push(`${ADDITIONAL_ACCOUNT_INFO}/${id}/${accountName}/${checkType}`)
    }

    // __renderAccountTable() {
    //     const { accountTable, searchValue } = this.state
    //     var nullData = (
    //         <div className="ml-4 mt-2">
    //             <div className="dataTables_info" id="DataTables_Table_0_info" role="status" aria-live="polite">Showing 0 of 0 entries</div>
    //             <div className="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate"></div>
    //         </div>
    //     )
    //     if (accountTable == null) {
    //         return nullData
    //     }
    //     else {
    //         return accountTable.filter(table => {
    //             if (searchValue == null) {
    //                 return table
    //             }
    //             else if (table.accountName.toLowerCase().includes(searchValue.toLowerCase())) {
    //                 return table
    //             }
    //         }).map((row, idx) => {
    //             return (
    //                 <tr key={idx}>
    //                     <td>{row.id}</td>
    //                     <td onClick={this.onRedirecting.bind(this, row.id, row.accountName,row.billingType)}><Link>{row.accountName}</Link></td>
    //                     <td>{row.accountEmail}</td>
    //                     <td>{row.createDate}</td>
    //                     <td>{row.balance}</td>
    //                     <td>{row.sessions}</td>
    //                     <td>{row.cps}</td>
    //                     <td>{row.active === false ? <span className="badge badge-danger">Suspend</span> : <span className="badge badge-success">Active</span>}</td>
    //                     {/* <td><span className="size-1"><Switch height={20} width={50} onChange={this.toggleSwitch.bind(this, row)} checked={row.status} /></span></td> */}
    //                     <td><i className="fa fa-edit mr-2" onClick={this.openEditModal.bind(this, row)}></i></td>
    //                 </tr>
    //             )
    //         })
    //     }

    // }

    render() {
        const { isGetting, isAddModal, isEditModal, editData, itemsCount, totalCount, isExpire, tableData, isDeleteModal, deleteData } = this.state
    
        let addAccountModal = {
            details: {
                info: "Create Account",
                msg: <AddAccount close={this.closeAddModal} classListing={this.getTable} />
            },
            confirmBtn: { label: "Update", action: '' },
            crossBtn: { action: this.closeAddModal },
            cancelBtn: { label: "Cancel", action: this.closeAddModal }
        }
        let editAccountModal = {
            details: {
                info: "Edit Account",
                msg: <EditAccount close={this.closeEditModal} previousData={editData} classListing={this.accountListing} />
            },
            confirmBtn: { label: "Update", action: '' },
            crossBtn: { action: this.closeEditModal },
            cancelBtn: { label: "Cancel", action: this.closeEditModal }
        }
        let deleteAccountModal = {
            details: {
                info: (
                    <span style={{ fontWeight: '600', fontSize: '15px', color: '#0F172A' }}>
                        Delete Account: {deleteData ? deleteData.accountName : ''}
                    </span>
                ),
                msg: (
                    <span style={{ fontSize: '13px', color: '#475569', lineHeight: '1.6' }}>
                        Are you sure you want to delete the account{' '}
                        <strong style={{ color: '#0F172A' }}>{deleteData ? deleteData.accountName : 'unknown'}</strong>? This action cannot be undone.
                    </span>
                ),
            },
            crossBtn: { action: this.closeDeleteModal, disabled: this.state.isDeleting },
            cancelBtn: { label: 'Cancel', action: this.closeDeleteModal, disabled: this.state.isDeleting },
            confirmBtn: {
                label: this.state.isDeleting ? (
                    <>
                        <span className="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
                        Deleting...
                    </>
                ) : 'Delete',
                action: this.handleDelete,
                disabled: this.state.isDeleting,
            },
        };
        let logoutModal = {
            details: {
                info: "Session Expire",
                msg:
                    <div className="row">
                        <div className="col-md-12">
                            <div class="alert alert-warning alert-styled-left alert-dismissible">
                                <button type="button" class="close" data-dismiss="alert"></button>
                                <span class="font-weight-semibold">Your session!</span> has expire please <a href="#" class="alert-link">login again</a>.
							    </div>
                        </div>
                        <button type="submit" className="btn bg-danger mr-2 ml-auto" onClick={this.goLoginPage}><i class="icon-key mr-2"></i>Login </button>
                    </div>
            },
            confirmBtn: { label: "Update", action: '' },
            crossBtn: { action: this.closeLogOutModal },
            cancelBtn: { label: "Cancel", action: this.closeLogOutModal }
        }
        return (
            <div>
                <CustomModal
                    visibility={isExpire}
                    customBodyCSS={"h20"}
                    modalType={"danger"}
                    modalHeader={"danger"}
                    details={logoutModal.details}
                    showBtns={false}
                    cancelBtn={logoutModal.cancelBtn}
                    crossBtn={logoutModal.crossBtn}
                />
                <CustomModal
                    visibility={isAddModal}
                    customBodyCSS={"h20"}
                    modalType={"success"}
                    details={addAccountModal.details}
                    modalSize={"large"}
                    showBtns={false}
                    cancelBtn={addAccountModal.cancelBtn}
                    crossBtn={addAccountModal.crossBtn}
                />
                <CustomModal
                    visibility={isEditModal}
                    customBodyCSS={"h20"}
                    modalType={"success"}
                    modalSize={"large"}
                    details={editAccountModal.details}
                    showBtns={false}
                    cancelBtn={addAccountModal.cancelBtn}
                    crossBtn={editAccountModal.crossBtn}
                />
                <CustomModal
                    visibility={isDeleteModal}
                    modalType={"danger"}
                    details={deleteAccountModal.details}
                    showBtns={true}
                    confirmBtn={deleteAccountModal.confirmBtn}
                    cancelBtn={deleteAccountModal.cancelBtn}
                    crossBtn={deleteAccountModal.crossBtn}
                />
                <div style={{display: 'flex', justifyContent: 'flex-end', marginBottom: '16px'}}>
                    <button
                        type="submit"
                        onClick={this.openAddModal}
                        style={{
                            background: 'linear-gradient(135deg, #10B981, #059669)',
                            color: '#fff',
                            border: 'none',
                            borderRadius: '10px',
                            padding: '9px 18px',
                            fontSize: '13px',
                            fontWeight: '600',
                            cursor: 'pointer',
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '6px',
                            boxShadow: '0 2px 8px rgba(16, 185, 129, 0.25)',
                            transition: 'all 150ms ease'
                        }}
                    >
                        <i className="fas fa-plus" style={{fontSize: '11px'}}></i>
                        Create Account
                    </button>
                </div>
                <div style={{
                    background: '#fff',
                    borderRadius: '12px',
                    border: '1px solid #E2E8F0',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.04), 0 1px 2px rgba(0,0,0,0.06)',
                    overflow: 'hidden'
                }}>
                    {/* <div className="card-header header-elements-inline">
                        <h3 className="card-title">Accounts Table</h3>
                        <div className="header-elements">
                            <button type="submit" className="btn bg-blue ml-3" onClick={this.openAddModal}>Add Account <i className="fas fa-plus ml-2"></i></button>
                        </div>
                    </div> */}
                    {/* <div style={{backgroundColor:'rgba(0,0,0,.03)',borderBottom:'1px solid rgba(0,0,0,.125)',padding:'.75rem 1.25rem'}} className="card-header">
                        <h3 style={{fontSize:'16px',fontWeight:'bolder', margin:'0 0 0.75rem 2px'}} className='card-titile'>Accounts Table</h3>
                    </div> */}
                    <div className="">
                        <p></p>
                        <div id="DataTables_Table_0_wrapper" className="dataTables_wrapper no-footer mt-1">
                            <div style={{border:'none'}} className="mb-1 datatable-header row">
                                <div id="DataTables_Table_0_filter" className=" col-md-6 col-sm-6 col-lg-4 dataTables_filter">
                                    {/* <label className="fs-16"><span>Search :</span>
                                        <input type="search" className="" placeholder="Type to filter..." value={this.state.searchValue} onChange={this.searchSpace} aria-controls="DataTables_Table_0" />
                                    </label> */}
                                    <div class="input-group">
                                        <input type="text" class="form-control border-right-0" value={this.state.searchValue} onChange={this.searchSpace} placeholder="Filter Account" />
                                        <span class="input-group-append">
                                            <button class="btn search-button" type="button"><i class="fa fa-search"></i></button>
                                        </span>
                                    </div>
                                </div>
                                <div className=" col-md-3 col-sm-3 col-lg-3 offset-lg-5  justify-content-end header-elements">
                                <div className="">
                            <Select
                                value={this.state.filterStatus}
                                onChange={this.handleSelectChange}
                                options={this.state.countList}
                                placeholder="Select status..."
                            />
                        </div>
                                </div>
                            </div>
                            <div className=" datatable-scroll " style={{ overflowX: 'auto', overflowY: 'auto', maxHeight: '56em' }}>
                                <table className="table-style table table-striped dataTable no-footer" id="DataTables_Table_0" role="grid" aria-describedby="DataTables_Table_0_info">
                                    <thead>
                                        {/* <tr className="bg-dark">
                                            <th>Account ID</th>
                                            <th>Account Name</th>
                                            <th>Account Email</th>
                                            <th>Join Date</th>
                                            <th>Balance</th>
                                            <th>Sessions</th>
                                            <th>CPS</th>
                                            <th>Status</th>
                                            <th>Actions</th>
                                        </tr> */}
                                        <tr className="stickeyHeader table-heading-style">
                                            <th>Account Name</th>
                                            <th style={{textAlign:'right'}}>Balance</th>
                                            <th style={{textAlign:'right'}}>Spent</th>
                                            <th style={{textAlign:'right'}}>Sessions</th>
                                            <th style={{textAlign:'right'}}>Sessions %</th>
                                            <th style={{textAlign:'right'}}>CPS</th>
                                            <th style={{textAlign:'right'}}>CPS %</th>
                                            <th style={{textAlign:'right'}}>ASR</th>
                                            <th style={{textAlign:'right'}}>ACD</th>
                                            <th style={{textAlign:'right'}}>SDP</th>
                                            <th style={{textAlign:'right'}}>Spent Yesterday</th>
                                            <th style={{textAlign:'right'}}>Profit</th>
                                            <th>Portal</th>
                                            <th>Rate</th>
                                            <th style={{textAlign:'center'}}>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {/* {isGetting ? <CustomLoader /> : this.__renderAccountTable()} */}
                                        {isGetting ? <CustomLoader /> : this.__renderAccountTable()}
                                        {tableData.length > 0 ? this.returnTotal() : ''}

                                    </tbody>
                                </table>
                            </div>
                            <div className="">
                            {totalCount >= 9 ?  
                                <div className="mt-3">
                                    <Pagination
                                        activePage={this.state.activePage}
                                        itemsCountPerPage={itemsCount}
                                        totalItemsCount={totalCount}
                                        pageRangeDisplayed={5}
                                        onChange={this.handlePageChange.bind(this)}
                                    />
                                </div> :''}

                                <div className="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate"></div>
                            </div>
                        </div> 
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(AccountTable)
